import { render, staticRenderFns } from "./TaskEnd.vue?vue&type=template&id=70ae9a8e"
import script from "./TaskEnd.vue?vue&type=script&lang=js"
export * from "./TaskEnd.vue?vue&type=script&lang=js"
import style0 from "./TaskEnd.vue?vue&type=style&index=0&id=70ae9a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports